import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromItems from './+state/items.reducer'
import { ItemsEffects } from './+state/items.effects'
import { ItemFacade } from './+state/items.facade'
import { GbDisplayNamePipe } from 'libs/shared/utils/pipes/src/lib/gb-display-name-pipe/gb-display-name.pipe'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromItems.ITEMS_FEATURE_KEY, fromItems.ItemReducer),
    EffectsModule.forFeature([ItemsEffects]),
  ],
  providers: [ItemFacade, GbDisplayNamePipe],
})
export class GbFrontItemDataAccessModule {}
